<template>
  <div class="payment-selector">
    <div class="payment-toggle payment-selector__toggle">
      <button
        class="payment-toggle__btn"
        :class="{'payment-toggle__btn--active': paymentMode === 'coupon' }"
        :style="buttonClass('coupon')"
        @click="paymentMode = 'coupon'"
        type="button"
        v-if="!paymentMethods || paymentMethods['coupon']">
        {{ $t('messages.paymentSelector.coupon') }}
      </button>
      <button
        class="payment-toggle__btn"
        :class="{'payment-toggle__btn--active': paymentMode === 'paypal' }"
        :style="buttonClass('paypal')"
        @click="paymentMode = 'paypal'"
        type="button"
        v-if="!paymentMethods || paymentMethods['paypal']">
        <i class="pf pf-paypal payment-toggle__icon" />
      </button>
      <button
        class="payment-toggle__btn"
        :class="{'payment-toggle__btn--active': paymentMode === 'mercadopago' }"
        :style="buttonClass('mercadopago')"
        @click="paymentMode = 'mercadopago'"
        type="button"
        v-if="!paymentMethods || paymentMethods['mercado_pago']">
        <i class="pf pf-mercado-pago payment-toggle__icon" />
      </button>
    </div>

    <template v-if="paymentMode === 'coupon'">
      <div class="payment-coupon payment-selector__coupon">
        <font-awesome-icon icon="gift" class="payment-coupon__icon" :style="textClass('coupon')"/>
        <template v-if="loadingCoupon">
          <img src="~images/loader.svg" class="mini-loading">
        </template>
        <input type="text" :placeholder="$t('messages.paymentSelector.placeholders.couponCode')" class="payment-coupon__input" v-model="couponCode" @input="checkCouponCode">
        <template v-if="coupon !== null">
          <span class="payment-coupon__balance" :class="{'payment-coupon__balance--error': coupon.campaignAmount < plotSize}">
            {{ $t('messages.paymentSelector.balance', { amount: coupon.campaignAmount, currency: coupon.campaignAmountCurrency }) }}
          </span>
          <span class="payment-coupon__balance payment-coupon__balance--error"
                v-if="!coupon.available && availableForActiveProject(coupon)">
            {{ $t('messages.errors.couponExpired') }}
          </span>
          <span class="payment-coupon__balance payment-coupon__balance--error"
                v-if="!coupon.available && !availableForActiveProject(coupon)">
            {{ $tc('messages.paymentSelector.errors.belongsOtherProjects',coupon.projects.length, { projects: joinStrings(coupon.projects.map(project => project.name)) }) }}
          </span>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
import HumanJoin from '../../mixins/human_join';
import { COUPON_CHECK_WAIT } from '../../store/constants';
import { camelize } from '../../helpers/fetch-helpers';
import { parseProjectPaymentMethods, getInitialPaymentMethod, isPaymentModeActive } from '../../helpers/map-helpers';

export default {
  props: {
    activeProject: { type: Object, required: true },
    interfaceColor: { type: String, required: true },
    plotSize: { type: Number, required: false, default: null },
  },
  mixins: [HumanJoin],
  data() {
    return {
      coupon: null,
      couponCode: null,
      loadingCoupon: false,
      paymentMode: null,
    };
  },
  computed: {
    paymentMethods() {
      return parseProjectPaymentMethods(camelize(this.activeProject));
    },
  },
  mounted() {
    this.paymentMode = getInitialPaymentMethod(this.paymentMethods) || 'paypal';
  },
  methods: {
    textClass(paymentMode) {
      if (this.interfaceColor && this.paymentMode === paymentMode) {
        return { color: `${this.interfaceColor}` };
      }

      return {};
    },
    buttonClass(paymentMode) {
      if (this.interfaceColor && this.paymentMode === paymentMode) {
        return { background: `${this.interfaceColor}`,
          border: `${this.interfaceColor}`,
          color: 'white' };
      }

      return { color: `${this.interfaceColor}` };
    },
    availableForActiveProject(coupon) {
      return (_.isEmpty(coupon.projects) ||
        coupon.projects.find(x => x.slug === this.activeProject.slug) !== undefined);
    },
    checkCouponCode: _.debounce(
      function () {
        if (this.couponCode) {
          this.loadingCoupon = true;
          this.$store.dispatch('checkCoupon', { couponCode: this.couponCode.toUpperCase(),
            activeProjectSlug: this.activeProject.slug })
            .then(coupon => {
              this.loadingCoupon = false;
              this.coupon = coupon || null;
            });
        } else {
          this.coupon = null;
        }
      },
      COUPON_CHECK_WAIT,
      {
        leading: true,
      }
    ),
  },
  watch: {
    coupon(val) {
      this.$emit('coupon-update', val);
    },
    paymentMode(val) {
      this.$emit('payment-change', val);
    },
    activeProject() {
      if (!isPaymentModeActive(this.paymentMethods, this.paymentMode)) {
        this.paymentMode = getInitialPaymentMethod(this.paymentMethods);
      }
    },
  },
};
</script>
